// Analytics related to the New Wix Plans page
// Analytics related to the Wix Plans page
import { trackNavigationEvent, analyticsDataRegistry } from '@vp/digital-tracking-lib-ubik'

enum PlansPageZones {
  Hero = 'Hero',
  Pricing = 'Pricing Section',
}
export enum TrackingListIds {
  ANONYMOUS_FLOW = 'Anonymous Flow',
  INITIAL_UPGRADE_FLOW = 'Initial Upgrade  Flow',
  CHANGE_PLAN_FLOW = 'Plan Change Flow',
  SECOND_UPGRADE_FLOW = 'Second Upgrade Flow',
}

const { wixPlans, wixMySites } = analyticsDataRegistry

const NAVIGATION_CLICKED_ACTION = 'Navigation Clicked'
const CREATE_A_FREE_VISTA_WIX_WEBSITE = 'Create a Free Website'
const PLANS_PRICING_LABEL = 'Content:Website Pricing Section'
const PLANS_CTA_LABEL = 'Content:Get Started'
const PLANS_NAVIGATION_LABEL = 'Content'
export const HERO_CTA_DETAIL = 'Start now for FREE'

// For enabling better QM Tracking
// Refer for detail: https://vistaprint.atlassian.net/wiki/spaces/GA/pages/2354546498/Phase+1+-+Vista+x+WIX+Partnership#Tracking-for-QM
export const PLANS_HERO_CTA_DATA_SECTION_LABEL = wixPlans.pageSection + ':' + PLANS_NAVIGATION_LABEL

export function trackPlansHeroCTAClick(destinationUrl: string) {
  wixMySites.pageUri = destinationUrl
  // Navigates to websites page
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    PLANS_CTA_LABEL,
    wixPlans, // source
    wixMySites, // target
    PlansPageZones.Hero,
    HERO_CTA_DETAIL,
  )
}

export function trackCreateFreeVistaWixWebsitePricingClick(destinationUrl: string) {
  wixMySites.pageUri = destinationUrl
  trackNavigationEvent(
    NAVIGATION_CLICKED_ACTION,
    PLANS_PRICING_LABEL,
    wixPlans, // source
    wixMySites, // target
    PlansPageZones.Pricing,
    CREATE_A_FREE_VISTA_WIX_WEBSITE,
  )
}
